<form
  class="kt-form"
  [formGroup]="quoteForm"
  autocomplete="off"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- <h4 class="form-error text-center text-danger" >Warning! This will overwrite the existing information.</h4> -->

    <mat-tab-group
      mat-align-tabs="center"
      dynamicHeight
      [selectedIndex]="activeTab"
    >
      <mat-tab label="{{ 'TITLES.PRODUCT_INFO' | translate }}">
        <div class="row w1024">
          <div class="col-md-6">
            <div class="form-group">
              <label for="" [translate]="'LABELS.PRODUCT_CATEGORY'"
                >Product Category</label
              >
              <select
                class="form-control"
                formControlName="product_category_id"
                (change)="getSubCategories()"
              >
                <option
                  [value]="bt.id"
                  *ngFor="let bt of productCategoriesSvc._productCategories | async"
                >
                  {{ bt.product_category }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_category_id"
              >
              </control-messages>
            </div>

            <div
              class="form-group"
              *ngIf="selectedCategory && selectedCategory.sub_categories"
            >
              <label for="">Product Sub Category</label>
              <select class="form-control" formControlName="sub_category_id">
                <option
                  *ngFor="let bt of selectedCategory.sub_categories"
                  [value]="bt.id"
                >
                  {{ bt.sub_category }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_category_id"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Preferred Supplier</label>
              <ng-select
                [items]="factories"
                formControlName="preferred_vendor_id"
                bindLabel="factory_name"
                bindValue="id"
              >
              </ng-select>
            </div>

            <div class="form-group">
              <label>Product Tags</label>
              <ng-select
                [items]="tags"
                formControlName="product_tags"
                bindValue="id"
                [searchFn]="customTagsSearchFn"
                multiple="true"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                    >×</span
                  >
                  <span [innerHTML]="item.name" class="d-inline"></span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-search="searchTerm"
                >
                  <h6 [innerHTML]="item.name"></h6>
                </ng-template>
              </ng-select>
            </div>

            <div class="form-group" *ngIf="lotTrackingEnabled">
              <mat-checkbox color="primary" formControlName="lot_tracking">
                Lot Tracking
              </mat-checkbox>
            </div>
            <div class="form-group">
              <mat-checkbox color="primary" formControlName="sellable">
                Sellable
              </mat-checkbox>
            </div>
          </div>

          <div class="col-md-6">
            <!-- <div class="form-group" *ngIf="product_type">
							<label for="">Product Type</label>
							<select class="form-control" formControlName="product_type_id">
								<option [value]="pt.id" *ngFor="let pt of settingsSvc.productTypes">
									{{pt.text}}</option>
							</select>
							<control-messages [submitted]="submitted" [control]="quoteForm.controls.product_type_id">
							</control-messages>
						</div> -->

            <div
              class="form-group"
              *ngIf="featureFlag.REMOVE_PRODUCT_DEPARTMENT | featureFlag"
            >
              <label for="">Product Department</label>
              <select class="form-control" formControlName="product_dept_id">
                <option
                  *ngFor="let pt of settingsSvc.productDepartments"
                  [value]="pt.id"
                >
                  {{ pt.text }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_dept_id"
              >
              </control-messages>
            </div>

            <div class="form-group" *ngIf="quoteForm.value.product_type_id == 2">
              <div class="row">
                <div class="col-md-4">
                  <label for="">Re-Order Level</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="reorder_level"
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Low Stock Alert Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="qty_limit_notify"
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Minimum Stock</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="oss_limit_notify"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-4">
                  <label for="">Wholesale Price</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="wholesale_price"
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Retail Price</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="retail_price"
                  />
                </div>
                <div class="col-md-4" *ngxPermissionsOnly="['skuUnitCost.read']">
                  <label for="">Unit Cost</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="unit_cost"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>
                <mat-checkbox
                  color="primary"
                  [checked]="quote_expires"
                  (change)="quote_expires = !quote_expires"
                ></mat-checkbox>
                Quote expires?
              </label>
              <input
                type="date"
                class="form-control"
                *ngIf="quote_expires"
                formControlName="expires_at"
              />
            </div>

            <div class="form-group">
              <mat-checkbox color="primary" formControlName="internal_use_only">
                Internal Use Only
              </mat-checkbox>
            </div>

            <div class="form-group">
              <label for="">Unit Class</label>
              <ng-select
                formControlName="unit_class_id"
                [items]="unitClasses$ | async"
                bindValue="id"
                bindLabel="name"
                [multiple]="false"
                [typeahead]="unitClassInput$"
                [trackByFn]="trackUnitClassByFn"
                [loading]="unitClassLoading$ | async"
                (change)="setUnitClass()"
                [clearable]="true"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.unit_class_id"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Selling Unit</label>
              <ng-select
                formControlName="default_selling_unit_id"
                [items]="unitMeasures$ | async"
                bindValue="id"
                bindLabel="name"
                [typeahead]="unitMeasureInput$"
                [trackByFn]="trackUnitMeasureByFn"
                [loading]="unitMeasureLoading$ | async"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.default_selling_unit_id"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Purchase Unit</label>
              <ng-select
                formControlName="default_purchase_unit_id"
                [items]="unitMeasures$ | async"
                bindValue="id"
                bindLabel="name"
                [typeahead]="unitMeasureInput$"
                [trackByFn]="trackUnitMeasureByFn"
                [loading]="unitMeasureLoading$ | async"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.default_purchase_unit_id"
              >
              </control-messages>
            </div>
          </div>
        </div>

        <div class="row w1024 mt-2">
          <div class="col-md-12">
            <div class="form-group">
              <div class="form-group">
                <label
                  >Product Links
                  <small>Please provide the product links in the market.</small>
                </label>
                <div formArrayName="product_links">
                  <div
                    *ngFor="
                      let rmk of quoteForm['controls'].product_links['controls'];
                      let idx = index
                    "
                  >
                    <div [formGroupName]="idx" class="width-ctrl">
                      <input
                        type="text"
                        class="form-control txt"
                        formControlName="lv"
                      />
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="addLink('product_links')"
                        *ngIf="idx == 0"
                      >
                        <i class="fas fa-plus"></i>
                      </a>
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="removeLink('product_links', idx)"
                        *ngIf="idx > 0"
                      >
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-group">
                <label
                  >Materials
                  <small>Please provide the product list of materials.</small>
                </label>
                <div formArrayName="material">
                  <div
                    *ngFor="
                      let rmk of quoteForm['controls'].material['controls'];
                      let idx = index
                    "
                  >
                    <div [formGroupName]="idx" class="width-ctrl">
                      <input
                        type="text"
                        class="form-control txt"
                        formControlName="mv"
                      />
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="addMaterials('material')"
                        *ngIf="idx == 0"
                      >
                        <i class="fas fa-plus"></i>
                      </a>
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="removeMaterials('material', idx)"
                        *ngIf="idx > 0"
                      >
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="">Link to Product Photo</label>
              <input type="text" class="form-control" formControlName="photo" />
            </div>
            <div class="form-group">
              <label for="">Link to Product Design</label>
              <input
                type="text"
                class="form-control"
                formControlName="product_design"
              />
            </div>

            <div class="form-group">
              <label for="" [translate]="'LABELS.PRODUCT_DESCRIPTION'"
                >Product Description</label
              >
              <angular-editor
                name="product_description"
                formControlName="product_description"
              >
              </angular-editor>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_description"
              >
              </control-messages>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoNextTab(1)"
            [translate]="'BUTTONS.NEXT'"
          >
            Next <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </mat-tab>

      <mat-tab label="Product Substitutions">
        <lum-rfq-product-substitution-form
          (onBulkEditProductSubstitutionDataEvent)="
            setProductSubstitutionData($event)
          "
          [productType]="productType"
          [isBulkEdit]="isBulkEdit"
          [excludeProductIds]="ids"
        ></lum-rfq-product-substitution-form>
      </mat-tab>

      <mat-tab label="{{ 'TITLES.SHIP_PACK_DETAILS' | translate }}">
        <div class="row w1280">
          <div class="col-md-6">
            <!-- 						<div class="form-group">
							<label for="">To Address</label>
							<textarea class="form-control" rows="3" formControlName="to_address"></textarea>
						</div>
						<div class="form-group">
							<label for="">From Address</label>
							<textarea class="form-control" rows="3" formControlName="from_address"></textarea>
						</div> -->

            <div class="form-group">
              <label for="">Shipment Value</label>
              <input
                type="number"
                class="form-control"
                formControlName="shipment_value"
              />
            </div>

            <div
              class="form-group"
              *ngIf="settingsSvc.settings$ | async as settings"
            >
              <label for="">Efficiency Score</label>
              <select class="form-control" formControlName="efficiency_score">
                <option value="0">--- Select efficiency score ---</option>
                <option *ngFor="let es of settings.labor_costs" [value]="es.score">
                  {{ es.score }} => {{ es.cost | currency: '' }}
                </option>
              </select>
            </div>

            <!-- <div class="form-group">
                            <label for="">Labor Cost</label>
                            <input type="number" class="form-control" formControlName="labor_cost">
                        </div> -->

            <div class="form-group">
              <label for="">Package Cost ($)</label>
              <input
                type="number"
                class="form-control"
                formControlName="package_cost"
              />
            </div>

            <div
              class="form-group"
              *ngIf="
                shippingCarrierSvc.shippingCarriers$ | async as shippingCarriers
              "
            >
              <label for="">Set Default Shipping</label>
              <select formControlName="default_shipping" class="form-control">
                <option value="0">--- Select default shipping ---</option>
                <option *ngFor="let sh of shippingCarriers.data" [value]="sh.id">
                  {{ sh.carrier_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <h6>Product Dimension</h6>
            <div class="form-group form-inline">
              <label for="">Weight</label>
              <a
                href="javascript:;"
                class="mx-2"
                (click)="addWeight('product_weight')"
                *ngIf="!quoteForm['controls'].product_weight['controls'].length"
              >
                <i class="fas fa-plus"></i> Add weight
              </a>
              <div class="weights" formArrayName="product_weight">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].product_weight['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input type="text" class="form-control" formControlName="wv" />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>

                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('product_weight', idx)"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>

                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('product_weight')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i> Add weight
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_length"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_width"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_height"
              />
            </div>

            <h6>Shipping Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <a
                href="javascript:;"
                class="mx-2"
                (click)="addWeight('shipping_weight')"
                *ngIf="!quoteForm['controls'].shipping_weight['controls'].length"
              >
                <i class="fas fa-plus"></i> Add weight
              </a>
              <div class="weights" formArrayName="shipping_weight">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].shipping_weight['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input type="text" class="form-control" formControlName="wv" />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('shipping_weight', idx)"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('shipping_weight')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i> Add weight
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_length"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_width"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_height"
              />
            </div>

            <h6>Box Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <a
                href="javascript:;"
                class="mx-2"
                (click)="addWeight('box_weight')"
                *ngIf="!quoteForm['controls'].box_weight['controls'].length"
              >
                <i class="fas fa-plus"></i> Add weight
              </a>
              <div class="weights" formArrayName="box_weight">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].box_weight['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input type="text" class="form-control" formControlName="wv" />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('box_weight', idx)"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('box_weight')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i> Add weight
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_length"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_width"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_height"
              />
            </div>

            <h6>Carton Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <a
                href="javascript:;"
                class="mx-2"
                (click)="addWeight('carton_weight')"
                *ngIf="!quoteForm['controls'].carton_weight['controls'].length"
              >
                <i class="fas fa-plus"></i> Add weight
              </a>
              <div class="weights" formArrayName="carton_weight">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].carton_weight['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input type="text" class="form-control" formControlName="wv" />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('carton_weight', idx)"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('carton_weight')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i> Add weight
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_length"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_width"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_height"
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of units per carton</label>
              <input
                type="number"
                class="form-control"
                formControlName="units_per_carton"
              />
            </div>

            <h6>Pallet Dimension</h6>
            <div class="form-group form-inline">
              <label for="">Weight</label>
              <a
                href="javascript:;"
                class="mx-2"
                (click)="addWeight('pallet_weight')"
                *ngIf="!quoteForm['controls'].pallet_weight['controls'].length"
              >
                <i class="fas fa-plus"></i> Add weight
              </a>
              <div class="weights" formArrayName="pallet_weight">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].pallet_weight['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input type="text" class="form-control" formControlName="wv" />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('pallet_weight', idx)"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('pallet_weight')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i> Add weight
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_length"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_width"
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_height"
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of cartons per pallet</label>
              <input
                type="number"
                class="form-control"
                formControlName="cartons_per_pallet"
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of units per pallet</label>
              <input
                type="number"
                class="form-control"
                formControlName="units_per_pallet"
              />
            </div>

            <div class="form-group">
              <mat-checkbox color="primary" formControlName="is_palletized">
                Palletized
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-secondary mr-1"
            (click)="activeTab = 0"
            [translate]="'BUTTONS.BACK'"
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
        </div>
      </mat-tab>

      <!-- <mat-tab label="Variants" *ngIf="rfq && !(rfq.variant_parent_id > 0)">
				<div class="row mb-5 w1024">
					<div class="col-md-12">
						<fieldset>
							<legend>Product Variants</legend>
							<mat-checkbox color="primary" formControlName="product_has_variants">
								{{ "LABELS.PRODUCT_HAS_VARIATION" | translate }}
							</mat-checkbox>
							<br />
							<table class="table table-striped" *ngIf="quoteForm.value.product_has_variants">
								<thead>
									<tr>
										<th [translate]="'TITLES.VARIANT_NAME'">Variant Name</th>
										<th [translate]="'TITLES.VARIANT_TERMS_VALUES'">Terms / Values</th>
										<th class="text-right">
											<a class="btn btn-default text-uppercase text-primary btn-sm" href="javascript:;" (click)="addVariant()" [translate]="'BUTTONS.ADD'">
												<i class="fas fa-plus mr-2"></i> ADD
											</a>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let variant of productVariants; let i = index">
										<td class="text-capitalize">
											{{ variant.variant_name }}
										</td>
										<td>
											{{ variant.variant_terms.join(", ") }}
										</td>
										<td class="actions text-right">
											<a href="javascript:;" (click)="addVariant(variant, i)" title="Edit">
												<i class="fas fa-edit fa-fw"></i>
											</a>
											<a href="javascript:;" (click)="productVariants.splice(i, 1)" class="text-danger" title="Remove">
												<i class="fas fa-trash fa-fw"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</fieldset>
					</div>
				</div>
				<div class="clearfix"></div>

				<div class="row w1024 action-button">
					<button type="button" class="btn btn-outline-secondary mr-1" (click)="activeTab = 0" [translate]="'BUTTONS.BACK'"><i class="fas fa-arrow-left"></i> Back</button>
					<button type="button" class="btn btn-outline-info" (click)="gotoNextTab(2)" [translate]="'BUTTONS.NEXT'">Next <i class="fas fa-arrow-right"></i></button>
				</div>
			</mat-tab>

			<mat-tab label="Others" *ngIf="false">
				<div class="form-group">
					<div class="form-group">
						<h4>
							Other Details
							<small>Manage custom product details here. Add labels and values accordingly.</small>
						</h4>
						<div formArrayName="custom_fields">
							<table class="table">
								<thead>
									<tr>
										<th>Label</th>
										<th>Value</th>
										<th width="40" class="text-right">&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let rmk of quoteForm['controls'].custom_fields['controls']; let idx = index" [formGroupName]="idx">
										<td>
											<input type="text" class="form-control txt" formControlName="l" />
										</td>
										<td>
											<input type="text" class="form-control txt" formControlName="v" />
										</td>
										<td>
											<a href="javascript:;" class="mx-2 btn" (click)="addField()" *ngIf="idx == 0">
												<i class="fas fa-plus"></i>
											</a>
											<a href="javascript:;" class="mx-2 btn" (click)="removeField(idx)" *ngIf="idx > 0">
												<i class="fas fa-times text-danger"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class="clearfix"></div>
				<div class="row w1280 action-button">
					<button type="button" class="btn btn-outline-secondary" (click)="activeTab = 3" [translate]="'BUTTONS.BACK'"><i class="fas fa-arrow-left"></i> Back</button>
				</div>
			</mat-tab> -->
    </mat-tab-group>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <button
      type="button"
      title="Save"
      [disabled]="loading || !quoteForm.valid"
      class="btn btn-info"
      (click)="submit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      <i class="fas fa-save"></i>
      Submit
    </button>
  </div>
</form>
